import { Fragment } from 'react';
import { Button } from '@upmc/ims.component-library';

import Profile from '../components/Profile';
import BulkProfile from '../components/BulkProfile';
import Icon from '../../../components/UI/Icon/Icon';
import WithLoadingHandler from '../../../hoc/withLoadingHandler/withLoadingHandler';
import * as utils from '../../../utils';
import classes from '../UserAccessReview.module.scss';
import { SubmitButton } from '../../../components/UI/Input/Button/index';
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';

const Edit = props => {
	return (
		<Fragment>
			<section
				id='edit-container'
				className={utils.concatenateClassNames(
					'edit-container',
					classes
				)}
			>
				{props.profile ? (
					<section>
						<Profile details={props.profile} navigation={false} />
					</section>
				) : (
					<section>
						<BulkProfile />
					</section>
				)}

				<WithLoadingHandler
					isLoading={props.loading?.isLoading}
					showChildren={true}
				>
					{props.loading?.isLoading ? (
						<Alert severity='info'>
							<AlertTitle>{props.loading?.title}</AlertTitle>{' '}
							{props.loading?.message}
						</Alert>
					) : (
						props.children
					)}
				</WithLoadingHandler>

				<section
					className={utils.concatenateClassNames(
						['edit__button--group'],
						classes
					)}
				>
					{props.cancellable ? (
						<Button
							disabled={props.cancellable.disabled}
							onClick={props.cancellable.handler}
							variant='outlined'
							endIcon={<Icon icon='cancel' />}
						>
							{
								props.cancellable && props.cancellable.label
									? props.cancellable.label
									: 'Cancel'
							}
						</Button>
					) : null}
					{props.submittable ? (
						<SubmitButton
							disabled={props.submittable.disabled}
							onClick={props.submittable.handler}
							endIcon={<Icon icon='done' />}
						>
							{
								props.submittable && props.submittable.label
									? props.submittable.label
									: 'Continue'
							}
						</SubmitButton>
					) : null}
				</section>
			</section>
		</Fragment>
	);
};

export default Edit;
